import { Control } from "../../business-objects/control/control.model";
import { PassAlertFailControlConfig } from "./pass-alert-fail-control-config.model";

export class PassAlertFailControl extends Control {
    config: PassAlertFailControlConfig;
}



// WEBPACK FOOTER //
// ./src/vas/controls/pass-alert-fail/pass-alert-fail-control.model.ts